import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useI18n } from "./I18nProvider";
import "../styles/ConfirmDialog.css";

const ConfirmContext = createContext(null);

// window.confirm yerine: const confirm = useConfirm(); if (!(await confirm("Silinsin mi?"))) return;
export const ConfirmProvider = ({ children }) => {
  const { t } = useI18n();
  const [state, setState] = useState(null); // { message, title, confirmLabel, danger }
  const resolverRef = useRef(null);

  const confirm = useCallback(
    (message, opts = {}) =>
      new Promise((resolve) => {
        resolverRef.current = resolve;
        setState({ message, ...opts });
      }),
    []
  );

  const close = useCallback((result) => {
    resolverRef.current?.(result);
    resolverRef.current = null;
    setState(null);
  }, []);

  useEffect(() => {
    if (!state) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") close(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [state, close]);

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {state && (
        <div className="confirm-backdrop" onMouseDown={() => close(false)}>
          <div
            className="confirm-dialog"
            role="alertdialog"
            aria-modal="true"
            onMouseDown={(e) => e.stopPropagation()}
          >
            {state.title && <h3>{state.title}</h3>}
            <p>{state.message}</p>
            <div className="confirm-actions">
              <button type="button" className="btn" onClick={() => close(false)}>
                {t("common.cancel")}
              </button>
              <button
                type="button"
                className={`btn ${state.danger === false ? "btn-approve" : "btn-reject"}`}
                autoFocus
                onClick={() => close(true)}
              >
                {state.confirmLabel || t("common.confirm")}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm must be used within ConfirmProvider");
  return ctx;
};
